import styled from "@emotion/styled";
import { theme } from "@styles/theme";
const { sm, md, lg, xl } = theme.breakpoints;

export const Container = styled.div`
  margin: 0 2em;
`;

export const Title = styled.div`
  font-family: "Poppins Regular";
  color: #6d6d6d;
  font-size: 1.2em;
  margin-top: 6vh;
`;
export const Line = styled.div`
  width: 100%;
  height: 1px;
  background-color: #a2a2a2;
  margin: 1vh 0;
`;
export const CaseList = styled.div`
  margin-top: 6vh;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  column-gap: 2em;
  min-height: 0;
  @media (max-width: ${xl}) {
    font-size: 12px;
  }
  @media (max-width: ${lg}) {
    font-size: 11px;
    margin-bottom: 5vh;
  }
  @media (max-width: ${md}) {
    grid-template-columns: repeat(3, 1fr);
    row-gap: 2em;
    margin-bottom: 5vh;
  }
  @media (max-width: ${sm}) {
    grid-template-columns: repeat(2, 1fr);
    row-gap: 2em;
    margin-bottom: 5vh;
  }
`;
